export default __webpack_public_path__ + "assets/background_blog_homepage.a9e94b31.webp";